// Vanilla JS conversion of smoke effect
// Original: http://www.html5canvastutorials.com/advanced/html5-canvas-realistic-smoke-effect/

// Create the smoke image and ensure it's loaded before starting
var smoke = new Image();
smoke.src = 'img/smoke.png'; // Changed image path as requested

// Wait for the DOM to be fully loaded
document.addEventListener('DOMContentLoaded', function() {
    var smokeCanvas = document.getElementById('smoke');
    
    // Set explicit dimensions for the canvas if needed
    if (!smokeCanvas.width) smokeCanvas.width = 800;
    if (!smokeCanvas.height) smokeCanvas.height = 800;
    
    // Wait for the image to load before starting the animation
    smoke.onload = function() {
        var emitter = createEmitter(smokeCanvas, {
            x: 300, // Reduced from 600 to ensure visibility
            y: 300, // Reduced from 600 to ensure visibility
            size: 70,
            particles: 50,
            speed: {
                x: -1,
                y: -2.5,
                fade: 150,
                acceleration: 400
            }
        });
        
        emitter.render();
    };
});

function createEmitter(el, opts) {
    var particles = [];
    var canvases = [];

    function Particle(canvas) {
        var x, y, size, speedX, speedY, opacity;
        reset();

        this.update = function() {
            if (opacity > 0) {
                opacity -= (Math.random() / opts.speed.fade);
            }
            if (opacity <= 0) {
                reset();
            }
            speedX -= Math.random() / opts.speed.acceleration;
            speedY -= Math.random() / opts.speed.acceleration;
            x += speedX;
            y += speedY;
            size += Math.random();
            drawParticle(x, y, size, opacity);
        };

        function drawParticle(x, y, size, opacity) {
            canvas.globalAlpha = opacity;
            canvas.drawImage(smoke, 0, 0, smoke.width, smoke.height, x, y, size, size);
        }

        function reset() {
            x = opts.x;
            y = opts.y;
            size = opts.size;
            speedX = Math.random() * opts.speed.x;
            speedY = Math.random() * opts.speed.y;
            opacity = Math.random();
        }
    }

    function Canvas(element) {
        var canvas = element.getContext('2d');
        
        // Store the actual canvas dimensions
        canvas.width = element.width;
        canvas.height = element.height;
        
        for (var c = 0; c < opts.particles; c++) {
            particles.push(new Particle(canvas));
        }
        
        this.clear = function() {
            canvas.clearRect(0, 0, canvas.width, canvas.height);
        };
    }

    // Handle single element
    canvases.push(new Canvas(el));

    function render() {
        canvases.forEach(function(canvas) {
            canvas.clear();
        });
        
        particles.forEach(function(particle) {
            particle.update();
        });
        
        window.requestAnimationFrame(render);
    }

    return {
        render: render
    };
}